import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import FocusLock, { AutoFocusInside } from 'react-focus-lock';
import ScrollLock from 'react-scrolllock';
import ModalContainer from './ModalContainer';
import ModalOverlay from './ModalOverlay';
import ModalDialog from './ModalDialog';
import ModalCloseButton from './ModalCloseButton';
import { ScrollWrapper } from '@uie/custom-scrollbar';
import { breakpoints } from '@vds-core/theme';
import { calculateRem } from '@uie/javascript-style-helpers';
import scroll from './util/scroll-lock';
import screenReader from './util/screen-reader';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';

var animateOut = function animateOut(vals) {
  var keyframeString = '';
  vals.map(function (val, index) {
    keyframeString += "".concat(index / vals.length * 100, "% {top: ").concat(val, "px }");
  });
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), keyframeString);
};

var animateIn = function animateIn(vals) {
  var keyframeString = '';
  vals.map(function (val, index) {
    keyframeString += "".concat(index / vals.length * 100, "% {top: ").concat(val, "px }");
  });
  return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), keyframeString);
};

var propTypes = {
  /**
   * @ignore
   */
  customScroll: PropTypes.bool,

  /**
   * @ignore
   */
  ariaLabel: PropTypes.string,

  /**
   * React components or HTML elements that will be in the ModalBody.
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  closeButton: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  /**
   * @ignore
   */
  showCloseButton: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  /**
   * @ignore
   */
  hideCloseButton: PropTypes.bool,

  /**
   * @ignore
   */
  disableOutsideClick: PropTypes.bool,

  /**
   * @ignore
   */
  showModal: PropTypes.bool,

  /**
   * @ignore
   */
  opened: PropTypes.bool,

  /**
   * @ignore
   */
  toggleModal: PropTypes.func.isRequired,

  /**
   * @ignore
   */
  unmounted: PropTypes.bool,

  /**
   * @ignore
   */
  modalHeight: PropTypes.string,

  /**
   * @ignore
   */
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @ignore
   */
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet']),

  /**
   * @ignore
   */
  styleConfig: PropTypes.object,

  /**
   * @ignore
   */
  fullScreenDialog: PropTypes.bool,

  /**
   * @ignore
   */
  fixedCloseButton: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * @ignore
   */
  disableFocusLock: PropTypes.bool
};
var defaultProps = {
  className: null,
  closeButton: undefined,
  showCloseButton: undefined,
  hideCloseButton: false,
  customScroll: false,
  disableOutsideClick: false,
  showModal: false,
  opened: false,
  unmounted: false,
  modalHeight: undefined,
  modalWidth: undefined,
  disableFocusLock: false,
  //1.0 Props
  viewport: 'desktop',
  fullScreenDialog: false,
  fixedCloseButton: false
};

var closeButton = function closeButton(props) {
  var closeButton = props.closeButton || props.showCloseButton; // If no closeButton passed at all, show Default Header Close Button

  if (typeof closeButton === 'undefined') {
    return /*#__PURE__*/React.createElement(ModalCloseButton, {
      toggleButton: props.toggleButton,
      onClick: props.toggleModal,
      fixedCloseButton: props.fixedCloseButton,
      styleConfig: props.styleConfig && props.styleConfig.modalCloseButton,
      isAppleDevice: props.isAppleDevice,
      unmounted: props.unmounted,
      keyPress: props.keyPress,
      ariaLabel: props.ariaLabel,
      "data-sitecat-cta": props.cta,
      "data-sitecat-level": props.level,
      "data-sitecat-position": props.position,
      "data-sitecat-datatrack": props.dataTrack,
      inverted: props.inverted,
      scrollbarId: props.scrollbarId
    });
  } // If closeButton passed in is null, don't show any Header Close Button


  if (props.closeButton === null && (props.showCloseButton === undefined || props.showCloseButton === false)) {
    return null;
  } // If closeButton is anything else, show it as the Header Close Button


  return props.closeButton ? props.closeButton : props.showCloseButton;
};

var ModalDialogWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalDialogWrapper",
  componentId: "sc-ov12ij-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  min-height: ", ";\n  padding: ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var styleConfig = _ref.styleConfig;
  return styleConfig && styleConfig.minHeight || calculateRem(232);
}, function (_ref2) {
  var styleConfig = _ref2.styleConfig,
      viewport = _ref2.viewport;
  return styleConfig && styleConfig.calcPadding && styleConfig.calcPadding(viewport);
}, function (_ref3) {
  var styleConfig = _ref3.styleConfig;
  return styleConfig && styleConfig.mobilePadding && styleConfig.calcPadding && "\n  @media (max-width: ".concat(breakpoints.md, ") {\n    padding: ").concat(styleConfig.calcPadding('mobile'), ";\n  }\n  ");
}, function (_ref4) {
  var customScroll = _ref4.customScroll;
  return customScroll && "\n    *::-webkit-scrollbar {\n      display: none;\n    }\n\n    *:not(select) {\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n    }\n\n    @media only screen and (min-width: ".concat(breakpoints.md, ") {\n      ::-webkit-scrollbar {\n        display: none;\n      }\n        scrollbar-width: none;\n        -ms-overflow-style: none;\n    }\n\n    @media only screen and (max-width: ").concat(breakpoints.md, ") {\n      ::-webkit-scrollbar {\n        display: auto;\n      }\n        scrollbar-width: auto;\n        -ms-overflow-style: auto;\n    }\n    ");
});
var ChildWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ChildWrapper",
  componentId: "sc-ov12ij-1"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  padding-left: 2px;\n  @media (max-width: ", ") {\n    padding: 0;\n  }\n"])), function (_ref5) {
  var renderScrollview = _ref5.renderScrollview,
      viewport = _ref5.viewport;
  return renderScrollview || viewport === 'mobile' ? 0 : '48px';
}, breakpoints.md);

var ModalBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalBase, _React$Component);

  var _super = _createSuper(ModalBase);

  function ModalBase(props) {
    var _this;

    _classCallCheck(this, ModalBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_renderScrollview", function (childHeight, dialogHeight) {
      if (childHeight > dialogHeight) {
        _this.setState({
          renderScrollview: true,
          childContainerHeight: childHeight
        });
      } else {
        _this.setState({
          renderScrollview: false,
          childContainerHeight: childHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updatePredicate", function () {
      var childContainerHeight = _this.state.childContainerHeight;

      var childHeight = _this.childrenContainer.getBoundingClientRect().height;

      var dialogHeight = _this.dialogContainerRef.getBoundingClientRect().height;

      if (childContainerHeight !== childHeight) {
        //if height is changed
        _this._renderScrollview(childHeight, dialogHeight);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_calcProgress", function (t) {
      var exp = Math.exp,
          sqrt = Math.sqrt,
          sin = Math.sin,
          cos = Math.cos;
      return -(13 * exp(-13 * t) * sin(sqrt(31) * t)) / sqrt(31) - exp(-13 * t) * cos(sqrt(31) * t) + 1;
    });

    _defineProperty(_assertThisInitialized(_this), "lerp", function (a, b, p) {
      return a + p * (b - a);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateSpring", function () {
      var distVals = [];
      var inVals = [];

      for (var i = 0; i <= 40; i++) {
        /* 40 because animation is 400ms  */
        var p = _this._calcProgress(i / 100);

        var distance = _this.lerp(0, window.innerHeight, p);

        distVals.push(distance);
        inVals.push(window.innerHeight - distance);
      }

      return {
        distVals: distVals,
        inVals: inVals
      };
    });

    _defineProperty(_assertThisInitialized(_this), "refPath", UNSAFE_SetEnvRef());

    _this.dialogContainerRef = null;
    _this.childrenContainer = null;
    _this.state = {
      modalHeight: 0,
      renderScrollview: false,
      childContainerHeight: 0
    };
    return _this;
  }

  _createClass(ModalBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.childrenContainer && this.dialogContainerRef) {
        //if refs are mounted, then check for scrollview
        this.setState({
          childContainerHeight: this.childrenContainer.getBoundingClientRect().height
        });
        this.updatePredicate();
      }

      window.addEventListener('resize', this.updatePredicate); //Enables body scroll locking for mobile devices

      this.props.isMobileDevice && scroll.enable(); // Fix talkback on Android devices

      this.props.isMobileDevice && !this.props.isAppleDevice && screenReader.OpenDialog();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var childContainerHeight = this.state.childContainerHeight;
      var childHeight = this.childrenContainer.getBoundingClientRect().height;

      if (prevProps.showModal !== this.props.showModal || childContainerHeight !== childHeight) {
        this.updatePredicate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.isMobileDevice && scroll.disable();
      window.removeEventListener('resize', this.updatePredicate); // Fix talkback on Android devices

      this.props.isMobileDevice && !this.props.isAppleDevice && screenReader.CloseDialog();
    }
  }, {
    key: "render",
    value: // use it to set either ref or innerRef prop
    function render() {
      var _this2 = this,
          _React$createElement;

      var _this$props = this.props,
          ariaLabel = _this$props.ariaLabel,
          children = _this$props.children,
          className = _this$props.className,
          disableOutsideClick = _this$props.disableOutsideClick,
          showModal = _this$props.showModal,
          opened = _this$props.opened,
          toggleModal = _this$props.toggleModal,
          unmounted = _this$props.unmounted,
          hideCloseButton = _this$props.hideCloseButton,
          customScroll = _this$props.customScroll,
          modalHeight = _this$props.modalHeight,
          modalWidth = _this$props.modalWidth,
          isMobileDevice = _this$props.isMobileDevice,
          isAppleDevice = _this$props.isAppleDevice,
          viewport = _this$props.viewport,
          styleConfig = _this$props.styleConfig,
          fullScreenDialog = _this$props.fullScreenDialog,
          fixedCloseButton = _this$props.fixedCloseButton,
          animationDistance = _this$props.animationDistance,
          colorConfig = _this$props.colorConfig,
          clickStream = _this$props.clickStream,
          analyticsTrack = _this$props.analyticsTrack,
          track = _this$props.track,
          zIndex = _this$props.zIndex,
          disableFocusLock = _this$props.disableFocusLock,
          id = _this$props.id,
          disableAnimation = _this$props.disableAnimation,
          inverted = _this$props.inverted;
      var showScrollview = customScroll && viewport !== 'mobile' && this.state.renderScrollview;
      return /*#__PURE__*/React.createElement(ModalContainer, {
        id: id,
        showModal: showModal,
        isMobileDevice: isMobileDevice,
        zIndex: zIndex
      }, /*#__PURE__*/React.createElement(FocusLock, {
        disabled: disableFocusLock,
        returnFocus: true
      }, /*#__PURE__*/React.createElement(ScrollLock, {
        isActive: showModal && !isMobileDevice
      }, /*#__PURE__*/React.createElement(ModalOverlay, {
        disableOutsideClick: disableOutsideClick,
        onDismiss: toggleModal,
        showModal: showModal,
        opened: opened,
        unmounted: unmounted,
        styleConfig: styleConfig && styleConfig.modalOverlay,
        fullScreenDialog: fullScreenDialog,
        viewport: viewport
      }, /*#__PURE__*/React.createElement(ModalDialog, (_React$createElement = {
        modalHeight: modalHeight,
        modalWidth: modalWidth,
        className: className,
        unmounted: unmounted,
        showModal: showModal,
        opened: opened,
        role: "dialog",
        "aria-modal": "true",
        viewport: viewport,
        styleConfig: styleConfig && styleConfig.modalDialog,
        fullScreenDialog: fullScreenDialog,
        animationDistance: animationDistance,
        colorConfig: colorConfig,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream
      }, _defineProperty(_React$createElement, "modalHeight", this.state.modalHeight), _defineProperty(_React$createElement, "animateIn", animateIn(this.calculateSpring().inVals)), _defineProperty(_React$createElement, "animateOut", animateOut(this.calculateSpring().distVals)), _defineProperty(_React$createElement, "disableAnimation", disableAnimation), _defineProperty(_React$createElement, "mobileHeight", window.innerHeight), _defineProperty(_React$createElement, "inverted", inverted), _React$createElement), !hideCloseButton && fixedCloseButton && closeButton(this.props), /*#__PURE__*/React.createElement(ModalDialogWrapper, _extends({
        viewport: viewport,
        fullScreenDialog: fullScreenDialog,
        styleConfig: styleConfig && styleConfig.modalDialogWrapper,
        isMobileDevice: isMobileDevice,
        customScroll: customScroll,
        id: !showScrollview ? this.props.contentContainer : null
      }, _defineProperty({}, this.refPath, function (elem) {
        return _this2.dialogContainerRef = elem;
      })), !hideCloseButton && !fixedCloseButton && closeButton(this.props), showScrollview ? /*#__PURE__*/React.createElement(ScrollWrapper, {
        height: fullScreenDialog ? 'calc(100vh - 94px)' : 'calc(70vh - 94px)',
        width: 'calc(100% - 11px)',
        contentStyle: {
          display: 'flex',
          flexDirection: 'column',
          paddingRight: 26
        },
        id: this.props.contentContainer,
        inverted: inverted,
        scrollbarId: this.props.scrollbarId
      }, /*#__PURE__*/React.createElement(ChildWrapper, _extends({
        renderScrollview: this.state.renderScrollview,
        viewport: viewport
      }, _defineProperty({}, this.refPath, function (elem) {
        return _this2.childrenContainer = elem;
      })), React.Children.map(children, function (child, index) {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          inverted: inverted
        }));
      }))) : /*#__PURE__*/React.createElement(ChildWrapper, _extends({
        renderScrollview: this.state.renderScrollview,
        viewport: viewport
      }, _defineProperty({}, this.refPath, function (elem) {
        return _this2.childrenContainer = elem;
      })), React.Children.map(children, function (child, index) {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          inverted: inverted
        }));
      }))))))));
    }
  }]);

  return ModalBase;
}(React.Component);

ModalBase.defaultProps = defaultProps;
ModalBase.propTypes = propTypes;
/** @component */

export default ModalBase;